import React, {Component} from 'react';
import Axios from "axios/index";
import supercluster from 'points-cluster';

const SharedMapContext = React.createContext();

const extractPoints = (data, selectedItemId) => {

    let res = {};

    if (typeof data === "object") {
        for (let category in data) {
            if (data.hasOwnProperty(category)) {
                res[category] = data[category].map((item) => {
                    return ({
                        id: parseInt(item.id),
                        lat: (parseFloat(item.lat)),
                        lng: (parseFloat(item.lng))
                    });
                });

                // delete selected item from the results
                res[category] = res[category].filter((item) => {
                    return (item.id !== selectedItemId);
                });

            }
        }
    }

    return res;

};

const serialize = (obj, prefix) => {
    let str = [],
        p;
    if (typeof obj === "object") {
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                let k = prefix ? prefix + "[" + p + "]" : p,
                    v = obj[p];
                str.push((v !== null && typeof v === "object") ?
                    serialize(v, k) :
                    encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
    }
    return str.join("&");
};

export class SharedMapContextProvider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            googleApi: null,
            googleMapObject: null,
            selectedItem: null,
            prices: {},
            items: {},
            points: {},
            clusters: {},
            visibility: {
                house: props.defaultType === 'house',
                beach: props.defaultType === 'beach',
                beach_club: props.defaultType === 'beach_club',
                club: props.defaultType === 'club',
                place: props.defaultType === 'place',
                restaurant: props.defaultType === 'restaurant',
                store: props.defaultType === 'store',
                market: props.defaultType === 'market'
            },
            mapOptions: {
                center: props.center,
                zoom: props.zoom,
            },
            visibleTooltipItemId: 0,  // id of the item o which current tootlip is visible. 0 for none.
        };

        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.handleMapChange = this.handleMapChange.bind(this);
        this.getItemById = this.getItemById.bind(this);
        this.handleMarkerClick = this.handleMarkerClick.bind(this);
        this.handleCloseTooltip = this.handleCloseTooltip.bind(this);
        this.handlePricesChange = this.handlePricesChange.bind(this);
        this.mapOptionsCreator = this.mapOptionsCreator.bind(this);
        this.googleApiLoaded = this.googleApiLoaded.bind(this);
        this.latlngWithOffset = this.latlngWithOffset.bind(this);
    }

    componentDidMount() {

        const selectedItemId = parseInt(document.getElementById('map-root').getAttribute('data-item-id'));

        /**************************************************************************************************************
         * Mutation observer config
         **************************************************************************************************************/
        const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        const element = document.querySelector('#map-root');
        let myThis = this;

        let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {

                /**************************************************************************************************************
                 * Dates updated in house search form -> update prices
                 **************************************************************************************************************/
                if (mutation.type === "attributes" && mutation.attributeName === "data-prices-request") {
                    myThis.handlePricesChange();
                }
            });
        });

        observer.observe(element, {
            attributes: true //configure it to listen to attribute changes
        });

        /**************************************************************************************************************
         * Read all items
         **************************************************************************************************************/
        // Make a request for a user with a given ID

        const locale = document.getElementsByTagName('html')[0].getAttribute('lang');
        let appUrl = document.getElementsByTagName('body')[0].getAttribute('data-ibiza-website-url');
        
        Axios.get(appUrl+ '/api/map/all_items/'+locale)
            .then(function (response) {
                // handle success
                myThis.setState({
                    items: response.data,
                    points: extractPoints(response.data, selectedItemId)
                });

                // we have all items from the server so it is time to adjust the map in case there is a selectedItem
                if (selectedItemId > 0) {

                    // find item by its id
                    let foundItem = null;

                    if (typeof response.data === "object") {
                        for (let category in response.data) {
                            if (response.data.hasOwnProperty(category)) {
                                for (let item in response.data[category]) {
                                    if (response.data[category][item].id === selectedItemId) {
                                        foundItem = response.data[category][item];
                                        foundItem = {...foundItem, category: category};
                                        break;
                                    }
                                }
                            }
                        }
                    }

                    if (foundItem !== null) {

                        // set center and zoom to this element
                        myThis.handleMapChange({
                            ...myThis.state.mapOptions,
                            center: {
                                lat: foundItem.lat,
                                lng: foundItem.lng
                            },
                            zoom: 13
                        });

                        // save element to state
                        myThis.setState({
                            selectedItem: foundItem
                        });
                    }
                }

                myThis.handlePricesChange();    // always check prices on setup, it will also create clusters

            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });

    };

    mapOptionsCreator(map) {

        this.setState({googleMapObject: map});

        return {
            zoomControlOptions: {
                position: map.ControlPosition.LEFT_TOP,
                style: map.ZoomControlStyle.DEFAULT
            },
            // streetViewControl: true,
            // streetViewControlOptions: {
            //     position: map.ControlPosition.LEFT_CENTER
            // },
            mapTypeControl: false,
            fullscreenControl: false,
            gestureHandling: 'greedy'
            // mapTypeControlOptions: {
            //     mapTypeIds: ['roadmap', 'satellite'],
            //     style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            //     position: map.ControlPosition.RIGHT_TOP
            // }
        };
    };

    latlngWithOffset(latlng, offsetx, offsety) {

        const overlay = new this.state.googleApi.maps.OverlayView();
        overlay.draw = function () {
        };
        overlay.setMap(this.state.googleApi.map);

        const projection = overlay.getProjection();
        const gLatLng = new this.state.googleApi.maps.LatLng(latlng);
        const containerPixel1 = projection.fromLatLngToContainerPixel(gLatLng);
        const containerPixel2 = {...containerPixel1, x: containerPixel1.x - offsetx, y: containerPixel1.y - offsety};
        const newLatLng = projection.fromContainerPixelToLatLng(containerPixel2);
        return {lat: newLatLng.lat(), lng: newLatLng.lng()};
    };

    googleApiLoaded(api) {
        this.setState({googleApi: api});
    };

    handlePricesChange() {

        const requestData = document.getElementById('map-root').getAttribute('data-prices-request');
        const myThis = this;

        if (requestData !== null && requestData !== '') {

            const obj = JSON.parse(requestData);
            const postData = serialize(obj);

            Axios.post('/api/houses/get_houses_list_prices', postData)
                .then(function (response) {
                    // handle success
                    myThis.setState({prices: response.data.result},
                        () => {
                            myThis.createClusters(myThis.props);
                        });
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })

        } else {
            // clear
            this.setState({prices: {}},
                () => {
                    this.createClusters(this.props);
                });
        }
    };

    toggleVisibility(field) {
        let visibility = this.state.visibility;
        visibility = {...visibility, [field]: !visibility[field]};
        this.setState({visibility},
            () => {
                this.createClusters(this.props);
            });
    };

    getClusters(props) {

        let clusters = {};

        if (typeof this.state.points === "object") {
            for (let category in this.state.points) {
                if (this.state.points.hasOwnProperty(category) && this.state.visibility[category]) {

                    // by default we take all items
                    let pointsForSuperCluster = this.state.points[category];

                    // but if there are price search results, only houses that are found in search are needed

                    // category = house, prices is not empty
                    if (typeof this.state.prices === 'object'
                        && this.state.prices.constructor === Object
                        && category === 'house'
                        && Object.keys(this.state.prices).length !== 0) {

                        let pricesIdArray = Object.keys(this.state.prices);
                        pricesIdArray = pricesIdArray.map((p) => {
                            return parseInt(p)
                        });

                        pointsForSuperCluster = pointsForSuperCluster.filter(function (p) {
                            return pricesIdArray.includes(p.id);
                        });
                    }

                    // edge case: if lat/lng property is null supercluster will fail and points won’t appear
                    // so we remove the one that has a missing lat/lng
                    pointsForSuperCluster.forEach((point, index) => {
                        if (!point.lat || !point.lng) {
                            pointsForSuperCluster.splice(index, 1)
                        }
                    })

                    clusters[category] = (supercluster(pointsForSuperCluster, {
                        minZoom: 0,
                        maxZoom: 16,
                        radius: 100,
                    }))(this.state.mapOptions);
                }
            }
        }

        return clusters;
    };

    createClusters(props) {

        const superClusters = this.getClusters(props);
        let clusters = {};

        if (this.state.mapOptions.bounds) {
            for (let category in superClusters) {
                clusters[category] = superClusters[category].map(({wx, wy, numPoints, points}) => ({
                    lat: wy,
                    lng: wx,
                    numPoints,
                    id: `${numPoints}_${points[0].id}`,
                    points,
                }));
            }
            this.setState({clusters});
        } else {
            this.setState({clusters: {}});
        }

    };

    handleMapChange({center, zoom, bounds}) {
        this.setState(
            {
                mapOptions: {
                    center,
                    zoom,
                    bounds,
                },
            },
            () => {
                this.createClusters(this.props);
            }
        );
    };

    getItemById(itemId) {
        if (typeof this.state.items === "object") {
            for (let category in this.state.items) {
                for (let item in this.state.items[category]) {
                    if (this.state.items[category][item].id === itemId)
                        return this.state.items[category][item];
                }
            }
        }
        return null;
    };

    handleMarkerClick(itemId) {
        if (this.state.visibleTooltipItemId === itemId) {
            this.setState({visibleTooltipItemId: 0});       // hide
        } else {
            // find where to center the map
            let foundItem = [];
            if(typeof this.state.items === "object") {
                for (let category in this.state.items) {
                    if (this.state.items.hasOwnProperty(category) && foundItem.length <= 0) {
                        // find selected item in the results
                        foundItem = this.state.items[category].filter((item) => {
                            return (item.id === itemId);
                        });
                    }
                }
            }

            if (foundItem.length > 0) {
                const newCenter = this.latlngWithOffset({
                    lat: foundItem[0].lat,
                    lng: foundItem[0].lng
                }, 0, this.props.height / 2 - 120);
                this.handleMapChange({
                    ...this.state.mapOptions,
                    center: newCenter
                });
            }

            // show tooltip
            this.setState({visibleTooltipItemId: itemId});

        }
    };

    handleCloseTooltip() {
        this.setState({visibleTooltipItemId: 0});
    }

    render() {
        const {children} = this.props;

        return (
            <SharedMapContext.Provider
                value={{
                    mapOptionsCreator: this.mapOptionsCreator,
                    selectedItem: this.state.selectedItem,
                    toggleVisibility: this.toggleVisibility,
                    items: this.state.items,
                    points: this.state.points,
                    visibility: this.state.visibility,
                    clusters: this.state.clusters,
                    mapOptions: this.state.mapOptions,
                    handleMapChange: this.handleMapChange,
                    getItemById: this.getItemById,
                    prices: this.state.prices,
                    visibleTooltipItemId: this.state.visibleTooltipItemId,
                    handleMarkerClick: this.handleMarkerClick,
                    handleCloseTooltip: this.handleCloseTooltip,
                    googleApiLoaded: this.googleApiLoaded
                }}
            >
                {children}
            </SharedMapContext.Provider>
        );
    }
}

export const SharedMapContextConsumer = SharedMapContext.Consumer;